export default __webpack_public_path__ + "static/media/andes_a_la_costa_26.2867d544.jpg";